import { createUseStyles } from "react-jss";
import { pxToRem } from "@/util/common";

function useCustomStyles() {
	const useStyles = createUseStyles({
		cardWrap: {
			borderRadius: pxToRem(10),
			border: "1px solid #353F63",
			// borderImageSource:
			// 	"linear-gradient(180deg, #2E3A61 0%, #353F63 100%)",
			marginBottom: pxToRem(10),
			background: "linear-gradient(156deg, #181B24 5.2%, #232C48 97.46%)",
			"& .head": {
				display: "flex",
				lineHeight: pxToRem(24),
				paddingBottom: pxToRem(12),
				borderBottom: "1px solid #2F3A62",
				"& .l": {
					flex: 1,
					overflow: "hidden",
					fontSize: pxToRem(16),
					fontWeight: "bold",
					color: "#FFFFFF",
				},
				"& .r": {
					fontSize: pxToRem(14),
					color: "#FFFFFF",
				},
				"& span": {
					"&:last-of-type": {
						marginLeft: pxToRem(6),
					},
				},
			},
			"& .c8BFF78": {
				color: "#8BFF78",
			},
		},
		rebateWrap: {
			height: pxToRem(40),
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			background: "#12141A",
			padding: {
				left: pxToRem(18),
				right: pxToRem(12),
			},
			borderBottom: "1px solid #2F3A62",
			"& >span": {
				color: "#FFFFFF",
				fontFamily: "Poppins",
				fontWeight: "400",
				fontSize: pxToRem(14),
				lineHeight: pxToRem(100),
				letterSpacing: pxToRem(0),
				textTransform: "capitalize",
			},
		},
		dlWrap: {
			paddingTop: pxToRem(16),
			"& dt": {
				color: "#868FA8",
				fontSize: pxToRem(14),
				fontWeight: "400",
				lineHeight: pxToRem(22),
				marginBottom: pxToRem(6),
			},
			"& dd": {
				color: "#FFFFFF",
				fontSize: pxToRem(16),
				fontWeight: "600",
				lineHeight: pxToRem(24),
				"&.tinydd": {
					fontSize: pxToRem(13),
					fontWeight: "400",
				},
				"&.c8BFF78": {
					color: "#8BFF78",
				},
			},
		},
	});

	return useStyles();
}

export default useCustomStyles;
